import { http } from 'services'
// initial state
const state = () => ({
  all: [],
  active: {},
  errors: null
})

// getters
const getters = {
}

// actions
const actions = {
  ['locationEmailSchedule.getAll'] ({ commit },params) {
    
    if (!params._q) params._q = null

    commit('CLEAR_ERRORS')

    return (http.get(`locations/${params.location_id}/location-emails/${params.location_email_id}/location-emails-schedules?_all=true`)).then ((res) => {
      commit('GET_ALL_LOCATION_EMAILS_SCHEDULES', res);
    })
    .catch ((res) => {
      commit('LOCATION_EMAILS_SCHEDULE_ERROR', res);
    })
  },
  ['locationEmailSchedule.new'] ({ commit , dispatch}, data) {
    commit('CLEAR_ERRORS')

    return (http.post(`locations/${data.location_id}/location-emails/${data.location_email_id}/location-emails-schedules`, data))
    .then ((res) => {
      dispatch('locationEmailSchedule.getAll',{location_id: data.location_id, location_email_id: data.location_email_id});
    })
    .catch ((res) => {
      commit('LOCATION_EMAILS_SCHEDULE_ERROR', res);
    })
  },
  ['locationEmailSchedule.edit'] ({ commit }, {id, data}) {
    commit('CLEAR_ERRORS')

    return (http.put(`locations/${data.location_id}/location-emails/${data.location_email_id}/location-emails-schedules/${id}`, data))
    .then ((res) => {
      commit('EDIT_LOCATION_EMAIL_SCHEDULE', res);
    })
    .catch ((res) => {
      commit('LOCATION_EMAILS_SCHEDULE_ERROR', res);
    })
  },
  ['locationEmailSchedule.remove'] ({ commit }, data) {
    commit('CLEAR_ERRORS')

    return (http.delete(`locations/${data.location_id}/location-emails/${data.location_email_id}/location-emails-schedules/${data.id}`))
    .then ((res) => {
      commit('REMOVE_LOCATION_EMAIL_SCHEDULE', data.id);
    })
    .catch ((res) => {
      commit('LOCATION_EMAILS_SCHEDULE_ERROR', res);
    })
  },

}

// mutations
const mutations = {
  GET_ALL_LOCATION_EMAILS_SCHEDULES (state, res) {
    state.all = res.data;
  },

  GET_LOCATION_EMAIL_SCHEDULE (state, res) {
    state.active = res.data
  },

  REMOVE_LOCATION_EMAIL_SCHEDULE (state, id) {
    state.all = _.filter(state.all, (item) => item.id != id);
  },

  EDIT_LOCATION_EMAIL_SCHEDULE (state, res) {
    state.active = res.data
  },

  //ERRORS
  LOCATION_EMAILS_SCHEDULE_ERROR (state, err) {
    try {
      state.errors = err.response.data;
    } catch (e) {
      state.errors = err;
    }
  },

  CLEAR_ERRORS (state) {
    state.errors = null
  }
}



export default {
  state,
  getters,
  actions,
  mutations
}
